export default {"src":"/_next/static/media/rubyIcon.88fdff8c.svg","height":32,"width":32};